import UsersNotFinishedRegistrationList from './UsersNotFinishedRegistrationList';

export default UsersNotFinishedRegistrationList;
